<template>
  <div class="py-1">
    <MenuOption
      id="add-text-block"
      :title="$t('W: Tekstblok')"
      @select="onAddTextBlockClick">
      <template #icon>
        <IconLucideAlignLeft class="h-4 w-4" />
      </template>
    </MenuOption>
    <MenuOption
      id="add-page-break"
      :title="$t('W: Sideskift')"
      @select="onAddPageBreakClick">
      <template #icon>
        <IconLucideSeparatorHorizontal class="h-4 w-4" />
      </template>
    </MenuOption>
  </div>
</template>

<script lang="ts">
export default {
  name: 'AddReportBlockMenu',

  emits: ['close'],

  props: {
    onAddTextBlock: {
      type: Function,
      required: true,
    },
    onAddPageBreak: {
      type: Function,
      required: true,
    },
  },

  methods: {
    onAddTextBlockClick(): void {
      this.onAddTextBlock()
      this.$emit('close')
    },

    onAddPageBreakClick(): void {
      this.onAddPageBreak()
      this.$emit('close')
    },
  },
}
</script>
